const getAddressFromSuggestions = (suggestions, id) => {
  const suggestion = suggestions.find((suggestion2) => suggestion2.id === id);
  const { title = "", subTitle } = suggestion ?? {};
  return `${title}${subTitle ? ", " + subTitle : ""}`;
};
export {
  getAddressFromSuggestions
};
//# sourceMappingURL=get-address-from-suggestions.js.map
